import styled from 'styled-components';

const StyledEmailListContainer = styled.div``;


export default StyledEmailListContainer;
